import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { imgBaseUrl } from "../../api/api";
import { formatToDateTime } from "../../pages/master/FormatToDateTime";

export default function NavBar() {
  const navigate = useNavigate();
  const initialToggleSide = localStorage.getItem("myToggleSide") === "false";
  const [toggleSide, setToggleSide] = useState(initialToggleSide);
  const isWideScreen = window.innerWidth <= 1200;

  const initialTheme = localStorage.getItem("myTheme") === "true";
  const [theme, setTheme] = useState(initialTheme);
  const effectTrigger = useRef(false);


  const changeTheme = () => {
    setTheme((prevTheme) => !prevTheme);
    effectTrigger.current = !effectTrigger.current;
  };

  useEffect(() => {
    if (effectTrigger.current) {
      effectTrigger.current = !effectTrigger.current;
      localStorage.setItem("myTheme", theme);
      const coreCss = document.querySelector(".template-customizer-core-css");
      const themeCss = document.querySelector(".template-customizer-theme-css");

      if (theme) {
        document.documentElement.setAttribute("data-style", "dark");
        if (coreCss && themeCss) {
          coreCss.setAttribute("href", "/assets/vendor/css/rtl/core-dark.css");
          themeCss.setAttribute(
            "href",
            "/assets/vendor/css/rtl/theme-default-dark.css"
          );
        }
      } else {
        document.documentElement.setAttribute("data-style", "light");
        if (coreCss && themeCss) {
          coreCss.setAttribute("href", "/assets/vendor/css/rtl/core.css");
          themeCss.setAttribute(
            "href",
            "/assets/vendor/css/rtl/theme-default.css"
          );
        }
      }
    }
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("myToggleSide", toggleSide);
    const SideMenu = localStorage.getItem("myToggleSide") === "true";
    if (isWideScreen) {
      if (SideMenu) {
        document.documentElement.className =
          "light-style layout-navbar-fixed layout-compact layout-menu-100vh layout-menu-fixed";
      } else {
        document.documentElement.className =
          "light-style layout-navbar-fixed layout-compact layout-menu-100vh layout-menu-fixed layout-menu-expanded";
      }
    }
  }, [toggleSide]);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <nav
        className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
        id="layout-navbar"
      >
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
          <a className="nav-item nav-link px-0 me-xl-6">
            <i
              className="ri-menu-fill ri-24px"
              onClick={() => setToggleSide(!toggleSide)}
            ></i>
          </a>
        </div>

        <div
          className="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse"
        >
          <button
            className="btn btn-outline-primary px-2 py-1 me-2"
            onClick={() => navigate(-1)}
          >
            <span className="ri-26px">←</span>
          </button>

          {/* {setting?.logo_img && (
            <img
              src={imgBaseUrl + setting?.logo_img}
              style={{ height: 40 }}
              alt=""
            />
          )}

          <p className="text-sm  m-0 ms-3">
            <span className="fw-bold ri-20px">{setting?.name}</span>
          </p>
          <p className="text-sm  m-0 ms-3">
            <span className="badge rounded-pill bg-label-primary">
              Session :{sessions?.find((s) => Number(s.status) === 1)?.session}
            </span>
          </p> */}

          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li className="nav-item ">
              <h5 className="mb-0 me-4">{formatToDateTime(time)}</h5>
            </li>
            <li className="nav-item me-1">
              <span className="nav-link btn btn-text-secondary rounded-pill btn-icon">
                <i
                  className={`${
                    theme ? "ri-moon-line" : "ri-sun-line"
                  }  ri-26px`}
                  onClick={changeTheme}
                />
              </span>
            </li>
            <li className="nav-item">
              <Link
                to={"/Logout"}
                className="nav-link btn btn-text-danger rounded-pill btn-icon btn-label-danger"
              >
                <img src="/files/logout.png" style={{ width: "25px" }} alt="" />
              </Link>
            </li>
          </ul>
        </div>

        {/* <!-- Search Small Screens --> */}
        <div className="navbar-search-wrapper search-input-wrapper d-none">
          <input
            type="text"
            className="form-control search-input container-xxl border-0"
            placeholder="Search..."
            aria-label="Search..."
          />
          <i className="ri-close-fill search-toggler cursor-pointer"></i>
        </div>
      </nav>
    </>
  );
}
